import { derived, writable } from "svelte/store";
import { utils } from "../src/services/Utils";
class WeatherStore {
    constructor(weatherData = writable([]), selectedTime = writable({}), 
    //   public cities: Writable<string[]> = writable([]),
    selectedCity = writable({ city: "", data: { city: "", forecast24h: [], forecast3h: [], forecast1h: [], observation: {} } }), sliderHours = writable([]), hourIndex = writable(0), dayIndex = writable(0), curretDay = writable(true), storedDate = writable({
        active: false,
        arrayLocation: "",
        city: "",
        clouds_icon_wwsyn_icon: "",
        clouds_shortText: "",
        clouds_shortText_wwsyn_shortText: "",
        date: "",
        dateByName: "",
        dateSLO: "",
        dd_shortText: "",
        ddff_icon: "",
        ff_shortText: "",
        ff_val: "",
        humidity: "",
        humidity_text: "",
        icon: "",
        icon_text: "",
        icon_text_capitalized: "",
        index: 0,
        msl: "",
        pa_shortText: "",
        position: "",
        presure: "",
        presure_text: "",
        rh: "",
        rh_shortText: "",
        selected: false,
        showDayName: false,
        sliderIndex: 0,
        sunrise: "",
        sunriseHour: "",
        sunset: "",
        sunsetHour: "",
        t: "",
        temperature: "",
        time: "",
        valid: "",
        wind: "",
        wind_speed: "",
        wind_text: "",
    }), carouselInstance = writable({}), combinedArray = writable({}), currentPage = writable(0), currentIndex = writable(0), loader = writable(true), firstPagesGroup = writable(true), lastPagesGroup = writable(false), InfoArray = writable([]), sliderData = writable([]), mobileCurrentCityObservationData = writable({})) {
        this.weatherData = weatherData;
        this.selectedTime = selectedTime;
        this.selectedCity = selectedCity;
        this.sliderHours = sliderHours;
        this.hourIndex = hourIndex;
        this.dayIndex = dayIndex;
        this.curretDay = curretDay;
        this.storedDate = storedDate;
        this.carouselInstance = carouselInstance;
        this.combinedArray = combinedArray;
        this.currentPage = currentPage;
        this.currentIndex = currentIndex;
        this.loader = loader;
        this.firstPagesGroup = firstPagesGroup;
        this.lastPagesGroup = lastPagesGroup;
        this.InfoArray = InfoArray;
        this.sliderData = sliderData;
        this.mobileCurrentCityObservationData = mobileCurrentCityObservationData;
    }
    get getMarkerTemperatures() {
        return derived([this.weatherData, this.storedDate, this.selectedCity], ([$weatherData, $storedDate, $selectedCity]) => {
            // Add null/undefined checks for input parameters
            if (!$weatherData || $weatherData.length === 0)
                return [];
            if (!$storedDate || Object.keys($storedDate).length === 0)
                return [];
            if (!$selectedCity)
                return [];
            let markerData = [];
            // Define a default template for tempElement to ensure all properties exist
            const createDefaultTempElement = () => ({
                active: false,
                arrayLocation: "",
                city: "",
                clouds_icon_wwsyn_icon: "",
                clouds_shortText: "",
                clouds_shortText_wwsyn_shortText: "",
                date: "",
                dateByName: "",
                dateSLO: "",
                dd_shortText: "",
                ddff_icon: "",
                ff_shortText: "",
                ff_val: "",
                humidity: "",
                humidity_text: "",
                icon: "",
                icon_text: "",
                icon_text_capitalized: "",
                index: 0,
                msl: "",
                pa_shortText: "",
                position: "",
                presure: "",
                presure_text: "",
                rh: "",
                rh_shortText: "",
                selected: false,
                showDayName: false,
                sliderIndex: 0,
                sunrise: "",
                sunriseHour: "",
                sunset: "",
                sunsetHour: "",
                t: "",
                temperature: "",
                time: "",
                valid: "",
                wind: "",
                wind_speed: "",
                wind_text: "",
            });
            try {
                $weatherData.forEach(weatherElement => {
                    var _a, _b, _c;
                    // Ensure weatherElement and its data exist
                    if (!weatherElement || !weatherElement.data)
                        return;
                    let processedElement = null;
                    switch ($storedDate["arrayLocation"]) {
                        case "forecast1h":
                            if (!weatherElement.data.forecast1h)
                                return;
                            weatherElement.data.forecast1h.forEach(forecastElement => {
                                var _a, _b, _c;
                                if (forecastElement.date === $storedDate.date) {
                                    processedElement = createDefaultTempElement();
                                    // Safely access timeline and index
                                    const timeline = forecastElement.timeline || [];
                                    const timelineIndex = $storedDate.index || 0;
                                    if (timeline[timelineIndex]) {
                                        processedElement = Object.assign(Object.assign(Object.assign({}, processedElement), timeline[timelineIndex]), { city: weatherElement.city || "", sunrise: forecastElement.sunrise || "", sunset: forecastElement.sunset || "", position: weatherElement.position || "", wind: utils.convertWindName(((_a = timeline[timelineIndex]) === null || _a === void 0 ? void 0 : _a.dd_shortText) || ""), icon: ((_b = timeline[timelineIndex]) === null || _b === void 0 ? void 0 : _b.clouds_icon_wwsyn_icon) || "", icon_text: ((_c = timeline[timelineIndex]) === null || _c === void 0 ? void 0 : _c.clouds_shortText_wwsyn_shortText) || "", selected: ($selectedCity === null || $selectedCity === void 0 ? void 0 : $selectedCity.city) === weatherElement.city });
                                        markerData.push(processedElement);
                                    }
                                }
                            });
                            break;
                        case "forecast3h":
                            if (!weatherElement.data.forecast3h)
                                return;
                            weatherElement.data.forecast3h.forEach(forecastElement => {
                                var _a, _b, _c;
                                if (forecastElement.date === $storedDate.date) {
                                    processedElement = createDefaultTempElement();
                                    const timeline = forecastElement.timeline || [];
                                    const timelineIndex = $storedDate.index || 0;
                                    if (timeline[timelineIndex]) {
                                        processedElement = Object.assign(Object.assign(Object.assign({}, processedElement), timeline[timelineIndex]), { city: weatherElement.city || "", sunrise: forecastElement.sunrise || "", sunset: forecastElement.sunset || "", position: weatherElement.position || "", wind: utils.convertWindName(((_a = timeline[timelineIndex]) === null || _a === void 0 ? void 0 : _a.dd_shortText) || ""), icon: ((_b = timeline[timelineIndex]) === null || _b === void 0 ? void 0 : _b.clouds_icon_wwsyn_icon) || "", icon_text: ((_c = timeline[timelineIndex]) === null || _c === void 0 ? void 0 : _c.clouds_shortText_wwsyn_shortText) || "", selected: ($selectedCity === null || $selectedCity === void 0 ? void 0 : $selectedCity.city) === weatherElement.city });
                                        markerData.push(processedElement);
                                    }
                                }
                            });
                            break;
                        case "observation":
                            if (!weatherElement.data.observation || !weatherElement.data.observation[0])
                                return;
                            if (weatherElement.data.observation[0].date === $storedDate.date) {
                                processedElement = createDefaultTempElement();
                                const observation = weatherElement.data.observation[0];
                                const timeline = observation.timeline || [];
                                const timelineIndex = $storedDate.index || 0;
                                if (timeline[timelineIndex]) {
                                    processedElement = Object.assign(Object.assign(Object.assign({}, processedElement), timeline[timelineIndex]), { city: weatherElement.city || "", sunrise: observation.sunrise || "", sunset: observation.sunset || "", position: weatherElement.position || "", wind: utils.convertWindName(((_a = timeline[timelineIndex]) === null || _a === void 0 ? void 0 : _a.dd_shortText) || ""), icon: ((_b = timeline[timelineIndex]) === null || _b === void 0 ? void 0 : _b.clouds_icon_wwsyn_icon) || "", icon_text: ((_c = timeline[timelineIndex]) === null || _c === void 0 ? void 0 : _c.clouds_shortText_wwsyn_shortText) || "", selected: ($selectedCity === null || $selectedCity === void 0 ? void 0 : $selectedCity.city) === weatherElement.city });
                                    markerData.push(processedElement);
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
                return markerData;
            }
            catch (error) {
                console.error("Error processing marker temperatures:", error);
                return [];
            }
        });
    }
    get observationData() {
        return derived([this.sliderData], ([$sliderData]) => {
            let combinedObservation;
            $sliderData.map(function (sliderElement, index) {
                sliderElement.showDayName = false;
                if ((sliderElement.index === 0) && (sliderElement.sliderIndex !== 0)) {
                    sliderElement.showDayName = true;
                }
                if ((sliderElement.index === 0) && (sliderElement.sliderIndex === 1)) {
                    sliderElement.showDayName = false;
                }
                if (sliderElement.active) {
                    combinedObservation = sliderElement;
                }
            });
            if (combinedObservation) {
                return combinedObservation;
            }
        });
    }
    get fiveDayData() {
        // Use derived to access writable values and export as readonly
        return derived([this.selectedCity], ([$selectedCity]) => {
            if ($selectedCity['data']) {
                // 
                let fiveDayArray = [];
                let tempArray = $selectedCity['data'].forecast24h.slice(0, 5);
                tempArray.map(function (element, index) {
                    let dateConverted = utils.convertDate(element.date);
                    let dayName;
                    let shortDayName;
                    switch (index) {
                        case 0:
                            dayName = 'Danes';
                            shortDayName = 'Danes';
                            break;
                        case 1:
                            dayName = 'Jutri';
                            shortDayName = 'Jutri';
                            break;
                        default:
                            dayName = utils.getDayName(element.date);
                            shortDayName = utils.getShortDayName(element.date);
                            break;
                    }
                    let combinedFiveDay = {
                        date: dateConverted,
                        date_name: dayName,
                        short_date_name: shortDayName,
                        sunrise: utils.convertTime(element.sunrise),
                        sunset: utils.convertTime(element.sunset),
                        icon: element.timeline[0].clouds_icon_wwsyn_icon,
                        icon_text: utils.capitalizeFirstLetter(element.timeline[0].clouds_shortText_wwsyn_shortText),
                        wind_text: element.timeline[0].ff_shortText,
                        wind_speed: element.timeline[0].ff_val,
                        presure: element.timeline[0].msl,
                        presure_text: element.timeline[0].pa_shortText,
                        humidity: element.timeline[0].rh,
                        humidity_text: element.timeline[0].rh_shortText,
                        maxTemp: element.timeline[0].txsyn,
                        minTemp: element.timeline[0].tnsyn,
                        wind: element.timeline[0].ddff_icon,
                        valid: element.timeline[0].valid,
                        selected: element.selected,
                        fullDate: utils.convertDateToReadable(element.date)
                    };
                    fiveDayArray.push(combinedFiveDay);
                });
                return Object.values(fiveDayArray);
            }
        });
    }
    get getMobileHoursView() {
        return derived([this.selectedCity, this.storedDate], ([$selectedCity, $storedDate]) => {
            if ($selectedCity.data && $storedDate) {
                let hoursArray = [];
                let sliderIndex = 0;
                $selectedCity.data.forecast1h.map(function (element, index) {
                    if (element.date === $storedDate.date) {
                        element.timeline.map(function (timelineElement, index) {
                            let selectedTime = {
                                "time": utils.convertTime(timelineElement.valid),
                                "validTime:": timelineElement.valid,
                                "date": element.date,
                                "index": index,
                                "sliderIndex": sliderIndex,
                                "temperature": timelineElement.t,
                                "icon": timelineElement.clouds_icon_wwsyn_icon,
                                "icon_text": timelineElement.clouds_shortText_wwsyn_shortText,
                                "wind": utils.convertWindName(timelineElement.dd_shortText),
                                "windSpeed": timelineElement.ff_val,
                                "active": false,
                                "next": false,
                                "sunriseHour": utils.convertTime(element.sunrise),
                                "sunsetHour": utils.convertTime(element.sunset),
                                "icon_text_capitalized": utils.capitalizeFirstLetter(timelineElement.clouds_shortText_wwsyn_shortText)
                            };
                            sliderIndex++;
                            hoursArray.push(selectedTime);
                        });
                    }
                });
                let lastPropInArray = $selectedCity.data.forecast1h.length - 1;
                //adding missing hour
                $selectedCity.data.forecast3h[lastPropInArray].timeline.map(function (element, index) {
                    let lastHourIn1h = utils.getHour($selectedCity.data.forecast1h[lastPropInArray].timeline[$selectedCity.data.forecast1h[lastPropInArray].timeline.length - 1].valid);
                    if ((utils.getHour(element.valid) > lastHourIn1h) && (element.date === $storedDate.date)) {
                        let selectedTime = {
                            "time": utils.convertTime(element.valid),
                            "validTime:": element.valid,
                            "date": element.date,
                            "index": index,
                            "sliderIndex": sliderIndex,
                            "temperature": element.t,
                            "icon": element.clouds_icon_wwsyn_icon,
                            "icon_text": element.clouds_shortText_wwsyn_shortText,
                            "active": element.active,
                            "sunriseHour": utils.convertTime($selectedCity.data.forecast3h[lastPropInArray].sunrise),
                            "sunsetHour": utils.convertTime($selectedCity.data.forecast3h[lastPropInArray].sunset),
                            "icon_text_capitalized": utils.capitalizeFirstLetter(element.clouds_shortText_wwsyn_shortText),
                            "wind": utils.convertWindName(element.dd_shortText),
                            "windSpeed": element.ff_val,
                        };
                        sliderIndex++;
                        hoursArray.push(selectedTime);
                    }
                });
                $selectedCity.data.forecast3h.map(function (element, index) {
                    if (index > 1 && index < 5) {
                        if (element.date === $storedDate.date) {
                            element.timeline.map(function (timelineElement, index) {
                                let selectedTime = {
                                    "time": utils.convertTime(timelineElement.valid),
                                    "validTime:": timelineElement.valid,
                                    "date": element.date,
                                    "index": index,
                                    "sliderIndex": sliderIndex,
                                    "temperature": timelineElement.t,
                                    "icon": timelineElement.clouds_icon_wwsyn_icon,
                                    "icon_text": timelineElement.clouds_shortText_wwsyn_shortText,
                                    "wind": utils.convertWindName(timelineElement.dd_shortText),
                                    "windSpeed": timelineElement.ff_val,
                                    "active": false,
                                    "next": false,
                                    "sunriseHour": utils.convertTime(element.sunrise),
                                    "sunsetHour": utils.convertTime(element.sunset),
                                    "icon_text_capitalized": utils.capitalizeFirstLetter(timelineElement.clouds_shortText_wwsyn_shortText)
                                    // "active" : timelineElement.active
                                };
                                sliderIndex++;
                                hoursArray.push(selectedTime);
                            });
                        }
                    }
                });
                return hoursArray;
            }
        });
    }
}
// Export a singleton
export const weatherStore = new WeatherStore();
